import { Platform } from 'react-native';
import {
  AAD_TENANT,
  AAD_CLIENT_ID,
  AAD_CLIENT_ID_NATIVE,
  AAD_SCOPE,
  AAD_REDIRECT_URI_WEB,
  AAD_REDIRECT_URI_NATIVE,
} from '@env';

/**
 * Azure AD (Entra ID) config for DigitalCampus.Server — sourced from .env.
 *
 * Web and native each authenticate against their own app registration, since
 * each platform has its own redirect URI:
 * - Web reuses the "digitaldevinternalUI" app registration (AAD_CLIENT_ID) the
 *   existing staff web frontends (src/frontend, src/frontendEmployee) already
 *   authenticate with. AAD_REDIRECT_URI_WEB is copied exactly from
 *   src/frontend/.env's NEXT_PUBLIC_AAD_REDIRECTURI, a confirmed-registered URI
 *   on that app registration — the ParentApp's web dev server must run on the
 *   same port that URI names (see web/webpack.config.js), and src/frontend's
 *   own dev server must not run at the same time (port collision).
 * - Native (Android/iOS) uses its own app registration (AAD_CLIENT_ID_NATIVE)
 *   with redirect URI AAD_REDIRECT_URI_NATIVE (msauth://com.vhvdigitalparent.app),
 *   registered under Authentication > Mobile and desktop applications.
 */
export const AuthConfig = {
  tenantId: AAD_TENANT,
  clientId: Platform.OS === 'web' ? AAD_CLIENT_ID : AAD_CLIENT_ID_NATIVE,
  redirectUri: Platform.OS === 'web' ? AAD_REDIRECT_URI_WEB : AAD_REDIRECT_URI_NATIVE,
  // Request the Backend API scope for both Web and Mobile to ensure the token Audience is correct
  scope: AAD_SCOPE.split(' ')[0],
};

export const authority = AuthConfig.tenantId.startsWith('http')
  ? AuthConfig.tenantId
  : `https://login.microsoftonline.com/${AuthConfig.tenantId}/v2.0`;

console.log('📋 [AuthConfig] Azure AD Configuration Loaded:');
console.log(`  Platform: ${Platform.OS}`);
console.log(`  TenantId: ${AuthConfig.tenantId}`);
console.log(`  ClientId: ${AuthConfig.clientId}`);
console.log(`  RedirectUri: ${AuthConfig.redirectUri}`);
console.log(`  Scope: ${AuthConfig.scope}`);
console.log(`  Authority: ${authority}`);
